import classnames from 'classnames';
import React, { Key, useState } from 'react';
import styles from '../styles/tabs.module.scss';

export type TabsProps = {
  children: (JSX.Element | null)[];
  defaultActiveKey?: string;
  activeKey?: string | number;
  style?: React.CSSProperties;
  className?: string;
};

export default function Tabs(props: TabsProps) {
  const [stateActiveKey, setStateActiveKey] = useState<Key | null>(null);

  const active = (
    props.activeKey ||
    stateActiveKey ||
    props.defaultActiveKey ||
    props.children[0]?.key
  )?.toString();

  return (
    <div className={classnames(styles.tabs, styles[`${props.className}`])} style={{ ...props.style }}>
      <header>
        {props.children.map((tab) =>
          tab ? (
            <div
              className={classnames(styles.tab, {
                [styles.tab_active]: tab.key === active,
              })}
              key={tab.key}
              onClick={() => {
                tab.props.onClick?.();
                setStateActiveKey(tab.key);
              }}
            >
              {tab.props.label}
              {tab.props.icon}
            </div>
          ) : null
        )}
      </header>
      {props.children.find((tab) => tab?.key === active)}
    </div>
  );
}

export function TabPane(props: {
  label: string | JSX.Element;
  children: JSX.Element;
  icon?: string | JSX.Element;
  className?: string;
  styles?: React.CSSProperties;
  onClick?: () => void;
}) {
  return (
    <div className={props.className} style={props.styles}>
      {props.children}
    </div>
  );
}
